import styled from 'styled-components';
import { heading3, body1, colors, link } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 75vh;
`;

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const StyledTitle = styled.div`
  ${heading3};
  text-align: center;
`;

export const StyledMessage = styled.div`
  ${body1};
  color: ${colors.textSecondary};
  margin-top: ${pxToRem(9)};
  text-align: center;
`;

export const StyledLinkContainer = styled.div`
  display: flex;
  font-size: ${pxToRem(16)};
  align-items: center;
  margin-top: ${pxToRem(17)};
  > :not(:last-child) {
    margin-right: ${pxToRem(5)};
  }
`;

export const RetryLink = styled.div`
  ${link};
  cursor: pointer;
  text-align: center;
`;
